<template>
  <div class="section-detail">
    <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions" @close="noticeVisible=false" />
    <div class="header">
      <button class="back-btn" @click="goBack">返回列表</button>
    </div>
    <div class="content" v-if="item">
      <h2 class="title">{{ item.title }}</h2>
      <div v-if="contentHtml(item)" class="detail-html" v-html="contentHtml(item)"></div>
      <div class="image" v-else-if="item.image || item.image_url">
        <img :src="resolveUrl(item.image_url || item.image)" alt="详情图片" />
      </div>
      <div v-else class="empty">暂无内容</div>
    </div>
    <div class="empty" v-else>
      正在加载内容...
    </div>
  </div>
</template>

<script>
import NoticeBar from './NoticeBar.vue'
export default {
  name: 'SectionDetail',
  components: { NoticeBar },
  props: {
    id: { type: [String, Number], required: true }
  },
  data() {
    return { item: null, noticeVisible: false, noticeMessage: '', noticeType: 'info', noticeActions: [] };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    resolveUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//.test(path)) return path;
      return path.startsWith('/') ? path : `/${path}`;
    },
    contentHtml(item) {
      const html = item?.content || item?.content_html || '';
      return typeof html === 'string' ? html : '';
    },
    async fetchDetail() {
      try {
        const res = await fetch(`/api/admin/section/public/${this.id}/`);
        if (!res.ok) throw new Error('获取二级目录详情失败');
        const data = await res.json();
        this.item = data;
      } catch (e) {
        console.error(e);
        this.showNotice('获取二级目录详情失败', 'error');
      }
    },
    showNotice(message, type = 'info', actions = [], autoHideMs = 2500) {
      this.noticeMessage = message
      this.noticeType = type
      this.noticeActions = actions
      this.noticeVisible = true
      if (autoHideMs > 0) setTimeout(() => { this.noticeVisible = false }, autoHideMs)
    },
    goBack() {
      // 仅发出回退事件，由父组件决定跳转登录或返回上级目录
      this.$emit('back');
    }
  }
}
</script>

<style scoped>
.section-detail { max-width: 880px; margin: 30px auto; background:#fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.header { display:flex; justify-content:flex-start; margin-bottom: 10px; }
.back-btn { padding: 8px 12px; background:#f5f5f5; border:1px solid #ddd; border-radius: 4px; cursor:pointer; }
.title { margin: 10px 0 16px; color:#2c3e50; }
.image img { max-width: 100%; border-radius: 6px; }
.empty { color:#888; text-align:center; padding: 40px 0; }
.detail-html { width: 100%; min-height: 240px; overflow: auto; padding: 16px; background: #ffffff; box-sizing: border-box; }
.detail-html { font-family: "Microsoft YaHei","Noto Sans SC",system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,"PingFang SC","Hiragino Sans GB"; font-size: 16px; line-height: 1.8; color: #111827; }
.detail-html p { margin: 0.6em 0; }
.detail-html h1 { font-size: 1.8em; margin: 0.8em 0 0.5em; font-weight: 700; }
.detail-html h2 { font-size: 1.6em; margin: 0.8em 0 0.5em; font-weight: 700; }
.detail-html h3 { font-size: 1.4em; margin: 0.8em 0 0.5em; font-weight: 700; }
.detail-html img { max-width: 100%; height: auto; }
.detail-html table { width: 100%; border-collapse: collapse; }
.detail-html th, .detail-html td { border: 1px solid #e5e7eb; padding: 6px; }
.detail-html ol, .detail-html ul { padding-left: 2em; margin: 0.6em 0; }
.detail-html li { margin: 0.4em 0; }
.detail-html blockquote { border-left: 3px solid #e5e7eb; margin: 0.8em 0; padding-left: 1em; color: #4b5563; }
.detail-html pre, .detail-html code { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; background: #f8fafc; border-radius: 6px; padding: 6px; }
.detail-html a { color: #2563eb; text-decoration: underline; }
</style>
